import styled from 'styled-components'

export const Container = styled.div`
  .ant-table-row {
    cursor: pointer;
  }
`
